(ns common.widgets.generic-upload
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["react-dropzone" :default ReactDropzone]
            ["src/svg/weather/cloud-arrow-up.svg$default" :as CloudArrowUp]
            [uix.core :refer [$ defui] :as uix]))

(defui file-select
  [{:keys [on-drop on-drop-rejected extensions multiple max-size]}]
  (let [ref (uix/use-ref)]
    ($ :div.file-select
       ($ Button {:on-click #(.click @ref)}
          "browse"
          ($ Box {:sx #js {:display "none"}}
             ($ :input {:type "file"
                        :accept extensions
                        :multiple multiple
                        :ref ref
                        :on-change #(when-let [files (js->clj
                                                      (.. js/window -Array
                                                          (from (-> % .-target .-files))))]
                                      (if (and (not (nil? max-size))
                                               (> (.-size (first files)) max-size))
                                        (on-drop-rejected)
                                        (on-drop files)))
                        :data-testid "file-input-2"}))))))

(defui upload [{:keys [class overlay preview relative-box] :& props}]
  ($ Box (when relative-box {:sx #js {:position "relative"}})
     overlay
     ($ ReactDropzone {:& props
                       :data-component :upload-component
                       :class (concat ["file-upload__dropzone"] class)
                       :accept-class-name "file-upload__dropzone--accept"
                       :reject-class-name "file-upload__dropzone--reject"
                       :disable-click true
                       :inputProps #js {:data-testid "file-input"}}
        ($ Stack
           ($ Stack {:direction "row"
                     :justify-content "center"
                     :align-items "center"
                     :sx #js {:px 2
                              :minHeight "64px"}}
              ($ CloudArrowUp)
              ($ Typography {:component "span"
                             :sx #js {:ml 1}}
                 "Drop files here or")
              ($ file-select props))
           (when preview
             ($ :<>
                ($ Divider)
                preview))))))
